import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col p-4"
}
const _hoisted_3 = { class: "flex flex-col bg-brand-dark-gray p-5 rounded-lg space-y-4" }
const _hoisted_4 = { class: "flex flex-col my-auto px-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-brand-light-gray font-medium text-lg text-center"
}
const _hoisted_6 = {
  key: 1,
  class: "text-white font-medium text-lg text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "py-16 m-auto"
}
const _hoisted_8 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_9 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feed_post = _resolveComponent("feed-post")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading && !_ctx.feed.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.isAuthUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, "They haven't added any posts yet."))
                : _createCommentVNode("", true),
              (_ctx.isAuthUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Any posts you create will show here."))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isAuthUser)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createPost && _ctx.createPost(...args))),
                  class: "w-full flex bg-black rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                    _createElementVNode("div", { class: "my-auto pt-0.5" }, [
                      _createElementVNode("div", null, "Create your first post")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            class: "animate-spin h-5 w-5 text-brand-light-gray",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.feed.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feed, (post) => {
              return (_openBlock(), _createBlock(_component_feed_post, {
                "can-view-user-profile": false,
                "auth-user": _ctx.authUser,
                key: post.id,
                post: post
              }, null, 8, ["auth-user", "post"]))
            }), 128))
          ]),
          (_ctx.showInfiniteScroll)
            ? (_openBlock(), _createBlock(_component_ion_infinite_scroll, {
                key: 0,
                onIonInfinite: _ctx.loadMore
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    class: "text-white",
                    "loading-spinner": "crescent"
                  })
                ]),
                _: 1
              }, 8, ["onIonInfinite"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}